/**
 * Napoli — axios instance with token auto-attach + 401 auto-logout.
 *
 * Anything frontend that talks to /api should import `api` from here, never
 * raw axios. Keeps token handling in one place.
 */
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;
export const TOKEN_KEY = "napoli_auth_token";

export const api = axios.create({
  baseURL: API_BASE,
  timeout: 20000,
  headers: { "Content-Type": "application/json" },
});

api.interceptors.request.use((config) => {
  const token =
    typeof window !== "undefined" ? window.localStorage.getItem(TOKEN_KEY) : null;
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

let onAuthFailure = null;
export const setAuthFailureHandler = (fn) => {
  onAuthFailure = fn;
};

api.interceptors.response.use(
  (r) => r,
  (error) => {
    const status = error?.response?.status;
    const url = error?.config?.url || "";
    // Don't auto-logout on the explicit /auth/me probe (it's how we DETECT auth)
    // or on the verify-code endpoint (a 401 there means "wrong code", not "session ended").
    const noAutoLogout =
      url.endsWith("/auth/me") ||
      url.endsWith("/auth/verify-code") ||
      url.endsWith("/auth/request-code");
    if (status === 401 && !noAutoLogout && typeof onAuthFailure === "function") {
      onAuthFailure();
    }
    return Promise.reject(error);
  }
);

export default api;
